import graphql__49fa57a0dfc14a0a55dc from "./__generated__/ConfigureAccountRouteQuery.graphql.js";import { Component } from "react";
import { graphql } from "react-relay";
import AppQueryRenderer from "../AppQueryRenderer";

import ConfigureAccount from "../Profile/ConfigureAccount";

class ConfigureAccountRoute extends Component {
  render() {
    return (
      <AppQueryRenderer
        query={ConfigureAccountRouteQuery}
        component={ConfigureAccount}
        additionalProps={this.props}
      />
    );
  }
}

const ConfigureAccountRouteQuery = graphql__49fa57a0dfc14a0a55dc;

export default ConfigureAccountRoute;
